import { tryFetch, HttpMethod, type HttpResponse } from '@/modules/services/http'
import type { MetricDeliveryStatusRequest } from './dashboard.requests'
import type {
  MetricAction,
  MetricDeliveryStatusResponse,
  MetricSetting,
} from '../models/dashboard.model'
import type { MetricErrorCode } from '../types/dashboard.enums'
import type { Filter } from '@/modules/filter/models/filter.model'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getSettings = async (): Promise<HttpResponse<MetricSetting, MetricErrorCode>> =>
  await tryFetch<MetricSetting, MetricErrorCode>(HttpMethod.Get, BASE_URL, ['metric', 'settings'], {
    view: true,
  })

const getActions = async (body: Filter): Promise<HttpResponse<MetricAction[], MetricErrorCode>> =>
  await tryFetch<MetricAction[], MetricErrorCode>(
    HttpMethod.Post,
    BASE_URL,
    ['metric', 'actions'],
    {
      view: true,
      body,
    },
  )

const getDeliveryStatus = async (
  body: MetricDeliveryStatusRequest,
): Promise<HttpResponse<MetricDeliveryStatusResponse, MetricErrorCode>> =>
  await tryFetch<MetricDeliveryStatusResponse, MetricErrorCode>(
    HttpMethod.Post,
    BASE_URL,
    ['metric', 'delivery-status'],
    {
      view: true,
      body,
    },
  )

export const dashboardApi = {
  getSettings,
  getActions,
  getDeliveryStatus,
}
